import { Link } from "react-router-dom";
import { formatBRL } from "@/lib/format";
import type { CustomerRecord, OrderRecord } from "@/types";

interface CheckoutSuccessProps {
  order: OrderRecord;
  customer: CustomerRecord;
  onContinue: () => void;
}

export default function CheckoutSuccess({ order, customer, onContinue }: CheckoutSuccessProps) {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-16 text-center md:py-24">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-50 text-primary-600">
          <i className="ri-checkbox-circle-line text-4xl" />
        </span>
        <h1 className="mt-6 font-heading text-3xl text-foreground-900 md:text-4xl">
          Tudo certo com o seu pedido
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          Abrimos o WhatsApp com o resumo completo. É só enviar a mensagem para a gente confirmar a
          disponibilidade, o prazo e o pagamento.
        </p>

        <div className="mt-8 w-full rounded-lg border border-background-200 bg-background-100 p-5 text-left">
          <div className="flex flex-col gap-2 text-sm text-foreground-700">
            <div className="flex items-center justify-between">
              <span>Pedido</span>
              <span className="font-medium text-foreground-900">{order.code}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Ficha do cliente</span>
              <span className="font-medium text-foreground-900">{customer.code}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Modalidade</span>
              <span className="text-foreground-800">{order.deliveryLabel}</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Quantidade de itens</span>
              <span className="text-foreground-800">{order.itemCount}</span>
            </div>
            <div className="mt-2 flex items-center justify-between border-t border-background-300 pt-3">
              <span className="font-heading text-lg text-foreground-900">Total estimado</span>
              <span className="font-heading text-lg text-primary-700">{formatBRL(order.total)}</span>
            </div>
          </div>
        </div>

        <p className="mt-6 text-xs text-foreground-500">
          Seu pedido ficou guardado neste navegador para o acompanhamento no atendimento.
        </p>

        <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={onContinue}
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-store-2-line text-base" />
            Continuar escolhendo
          </button>
          <Link
            to="/novidades"
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
          >
            Ver novidades
          </Link>
        </div>
      </div>
    </section>
  );
}